import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-lg" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "modal-title text-danger" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group-row" }
const _hoisted_9 = { class: "form-field" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group-row" }
const _hoisted_12 = { class: "form-field" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-group-row" }
const _hoisted_15 = { class: "form-field" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-group-row" }
const _hoisted_18 = { class: "form-field" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-group-row" }
const _hoisted_21 = { class: "form-field" }
const _hoisted_22 = { class: "form-group-row section-group" }
const _hoisted_23 = { class: "form-field" }
const _hoisted_24 = { class: "time-group" }
const _hoisted_25 = { class: "time-input" }
const _hoisted_26 = { class: "time-input" }
const _hoisted_27 = { class: "form-group-row section-group" }
const _hoisted_28 = { class: "form-field" }
const _hoisted_29 = { class: "financial-grid" }
const _hoisted_30 = { class: "financial-item" }
const _hoisted_31 = { class: "financial-item" }
const _hoisted_32 = { class: "financial-item" }
const _hoisted_33 = { class: "financial-item" }
const _hoisted_34 = { class: "form-group-row" }
const _hoisted_35 = { class: "form-field" }
const _hoisted_36 = {
  key: 0,
  class: "log-section"
}
const _hoisted_37 = {
  key: 0,
  class: "modal-backdrop fade show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogView = _resolveComponent("LogView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal", { show: _ctx.isModalVisible }]),
      tabindex: "-1",
      id: "jobUpdateModal",
      style: _normalizeStyle({ display: _ctx.isModalVisible ? 'block' : 'none' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.isEditMode ? 'Update Job Details' : 'Enter New Job Details'), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary btn-sm btn-header-action",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "bi bi-x-circle" }, null, -1),
                _createTextVNode(" Cancel ", -1)
              ]))]),
              (!_ctx.isEditMode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-success btn-sm btn-header-action",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.AddJob && _ctx.AddJob(...args)))
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("i", { class: "bi bi-save" }, null, -1),
                    _createTextVNode(" Save Job ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.isEditMode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-primary btn-sm btn-header-action",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.UpdateJob && _ctx.UpdateJob(...args)))
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "bi bi-pencil" }, null, -1),
                    _createTextVNode(" Update Job ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label" }, "Officer", -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedOfficerId) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onOfficerChange && _ctx.onOfficerChange(...args)))
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("option", {
                    value: "0",
                    disabled: ""
                  }, "Select Officer...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.officers, (officer) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: officer.id,
                      value: officer.id
                    }, _toDisplayString(officer.name), 9, _hoisted_10))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedOfficerId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label" }, "Site", -1)),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedSiteId) = $event)),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSiteChange && _ctx.onSiteChange(...args)))
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("option", {
                    value: "0",
                    disabled: ""
                  }, "Select Site...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: site.id,
                      value: site.id
                    }, _toDisplayString(site.name), 9, _hoisted_13))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedSiteId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label" }, "Client", -1)),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedJobClientId) = $event)),
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.OnClientChange && _ctx.OnClientChange(...args)))
                }, [
                  _cache[26] || (_cache[26] = _createElementVNode("option", {
                    value: "0",
                    disabled: ""
                  }, "Select Client...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSiteClients, (client) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: client.id,
                      value: client.id
                    }, _toDisplayString(client.name), 9, _hoisted_16))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedJobClientId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label" }, "Status", -1)),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedJobStatusId) = $event)),
                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.OnStatusChange && _ctx.OnStatusChange(...args)))
                }, [
                  _cache[28] || (_cache[28] = _createElementVNode("option", {
                    value: "0",
                    disabled: ""
                  }, "Select Status...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobStatuses, (jobStatus) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: jobStatus.id,
                      value: jobStatus.id
                    }, _toDisplayString(jobStatus.name), 9, _hoisted_19))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedJobStatusId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label" }, "Job Date", -1)),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedJobDate) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.selectedJobDate]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label section-label-wrapper" }, [
                _createElementVNode("span", { class: "section-label" }, [
                  _createTextVNode("Time "),
                  _createElementVNode("span", { class: "label-colon" }, ":")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", { class: "sub-label" }, "Start Time", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedJobStartTime) = $event)),
                      placeholder: "HH:MM"
                    }, null, 512), [
                      [_vModelText, _ctx.selectedJobStartTime]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", { class: "sub-label" }, "End Time", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedJobEndTime) = $event)),
                      placeholder: "HH:MM"
                    }, null, 512), [
                      [_vModelText, _ctx.selectedJobEndTime]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label section-label-wrapper" }, [
                _createElementVNode("span", { class: "section-label" }, [
                  _createTextVNode("Financials "),
                  _createElementVNode("span", { class: "label-colon" }, ":")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", { class: "sub-label" }, "Pay Rate", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedJobPayRate) = $event)),
                      step: "0.01",
                      placeholder: "0.00"
                    }, null, 512), [
                      [_vModelText, _ctx.selectedJobPayRate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "sub-label" }, "Adjustment", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedJobAdjustment) = $event)),
                      step: "0.01",
                      placeholder: "0.00"
                    }, null, 512), [
                      [_vModelText, _ctx.selectedJobAdjustment]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "sub-label" }, "T. Exp.", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedJobTravelExpense) = $event)),
                      step: "0.01",
                      placeholder: "0.00"
                    }, null, 512), [
                      [_vModelText, _ctx.selectedJobTravelExpense]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "sub-label" }, "B. Hrs.", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedJobBonusHours) = $event)),
                      step: "0.01",
                      placeholder: "0.00"
                    }, null, 512), [
                      [_vModelText, _ctx.selectedJobBonusHours]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label" }, "Remarks", -1)),
              _createElementVNode("div", _hoisted_35, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control remarks-textarea",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedJobRemarks) = $event)),
                  rows: "3",
                  placeholder: "Enter any additional notes..."
                }, null, 512), [
                  [_vModelText, _ctx.selectedJobRemarks]
                ])
              ])
            ]),
            (_ctx.currentJobId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _cache[40] || (_cache[40] = _createElementVNode("hr", null, null, -1)),
                  _cache[41] || (_cache[41] = _createElementVNode("h6", { class: "text-muted" }, [
                    _createElementVNode("i", { class: "bi bi-clock-history" }),
                    _createTextVNode(" Job History ")
                  ], -1)),
                  (_openBlock(), _createBlock(_component_LogView, {
                    key: _ctx.refreshKey,
                    officers: _ctx.officers,
                    baseUrl: _ctx.baseUrl,
                    sites: _ctx.sites,
                    jobStatuses: _ctx.jobStatuses,
                    entityType: 'Job',
                    entityId: _ctx.currentJobId
                  }, null, 8, ["officers", "baseUrl", "sites", "jobStatuses", "entityId"]))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 6),
    (_ctx.isModalVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37))
      : _createCommentVNode("", true)
  ], 64))
}